import React from 'react';
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import { IconEdit, IconTrash, IconZoomIn, IconEye } from '@tabler/icons-react';
import { useNavigateWithSlugHook, } from "../../../../src/config/routes/guards/slug";
import { formatDate } from '../../../helpers/formatDate';

const DatatableRiskManagementPlan = (props) => {
  // console.log(props);
  const containerStyle = {
    whiteSpace: 'pre-wrap', // Ini yang paling penting
  };

  const navigate = useNavigateWithSlugHook();
  const handleChangePage = (path) => {
    navigate(path);
  };

  const columns = [
    {
      name: 'Aksi',
      minWidth: '150px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <button
            className="btn btn-sm btn-outline-warning"
            type="button"
            title="Edit Rencana Penanganan Risiko"
            onClick={() => props.handleEditRiskManagementPlan(row)}
          >
            <IconEdit stroke={2} />
          </button>
          <button
            className="btn btn-sm btn-outline-danger"
            type="button"
            title="Hapus Rencana Penanganan Risiko"
            onClick={() => props.handleHapusRiskManagementPlan(row.id)}
          >
            <IconTrash stroke={2} />
          </button>
        </>
      ),
    },

    // {
    //   name: 'Nama Kegiatan',
    //   minWidth: '300px', // Set a minimum width for horizontal scroll
    //   cell: (row) => (
    //     <div
    //       style={{
    //         whiteSpace: 'normal',
    //         wordWrap: 'break-word',
    //         textAlign: 'center',
    //         width: '100%',
    //       }}
    //     >
    //       {row?.risk_profile?.risk_register?.risk_activity_target?.name}
    //     </div>
    //   ),
    //   style: {
    //     // You can also add more styles here
    //     whiteSpace: 'normal',
    //   },
    // },
    // {
    //   name: 'Tujuan Kegiatan',
    //   minWidth: '300px', // Set a minimum width for horizontal scroll
    //   cell: (row) => (
    //     <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
    //       {row?.risk_profile?.risk_register?.risk_activity_target?.goals}
    //     </div>
    //   ),
    //   style: {
    //     // You can also add more styles here
    //     whiteSpace: 'normal',
    //   },
    // },
    // {
    //   name: 'Opsi Teknik Penanganan Risiko',
    //   minWidth: '300px', // Set a minimum width for horizontal scroll
    //   cell: (row) => (
    //     <>
    //       <div style={{ textAlign: 'center', width: '100%' }}>
    //         {row?.risk_profile?.risk_register?.riskControl === '1'
    //           ? 'Hindari risiko'
    //           : row?.risk_profile?.risk_register?.riskControl === '2'
    //           ? 'Cegah kerugian (Mengurangi Probabilitas)'
    //           : row?.risk_profile?.risk_register?.riskControl === '3'
    //           ? 'Reduksi kerugian (Mengurangi Dampak)'
    //           : row?.risk_profile?.risk_register?.riskControl === '4'
    //           ? '  Segregasi (Pemisahan / Duplikasi)'
    //           : row?.risk_profile?.risk_register?.riskControl === '5'
    //           ? 'Contractual Transfer (Noninsurance)'
    //           : ''}
    //       </div>
    //     </>
    //   ),
    // },
    {
      name: 'Ranking',
      minWidth: '100px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {row?.risk_profile?.rank}
          </div>
        </>
      ),
    },
    {
      name: 'Uraian Penanganan Risiko',
      minWidth: '300px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={
              containerStyle
            }
          >
            {row?.risk_profile?.risk_register?.riskManagement}
          </div>
        </>
      ),
    },
    {
      name: 'Pengendalian yang sudah ada',
      minWidth: '250px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={
              containerStyle
            }
          >
            {row?.risk_profile?.risk_register?.existingControl}
          </div>
        </>
      ),
    },
    // {
    //   name: 'Tingkat Efektifitas',
    //   minWidth: '200px', // Set a minimum width for horizontal scroll
    //   cell: (row) => (
    //     <>
    //       <div
    //         style={{
    //           whiteSpace: 'normal',
    //           wordWrap: 'break-word',
    //           textAlign: 'center',
    //           width: '100%',
    //         }}
    //       >
    //         {row.isEffective}
    //       </div>
    //     </>
    //   ),
    // },
    {
      name: 'Pengendalian yang harus ada',
      minWidth: '250px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={
              containerStyle
            }
          >
            {row.action}
          </div>
        </>
      ),
    },
    {
      name: 'Rencana Kegiatan',
      minWidth: '300px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={
              containerStyle
            }
          >
            {row.alternativeRiskManagement}
          </div>
        </>
      ),
    },
    {
      name: 'Jenis',
      minWidth: '150px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {row.type}
          </div>
        </>
      ),
    },
    {
      name: 'Deadline',
      minWidth: '150px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {formatDate(row.deadline)}
          </div>
        </>
      ),
    },
    {
      name: 'Pemilik Risiko',
      minWidth: '150px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {
              row?.risk_profile?.risk_register?.risk_activity_target?.user
                ?.jabatan
            }{' '}
            {
              row?.risk_profile?.risk_register?.risk_activity_target?.user
                ?.risk_division?.namaDivision
            }
          </div>
        </>
      ),
    },
    {
      name: 'Penanggung Jawab TL Pengendalian',
      minWidth: '250px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {row.pic}
          </div>
        </>
      ),
    },
  ];

  const customStyles = {
    rows: {
      style: {
        borderBottom: '1px solid #ddd', // Garis bawah pada setiap baris
      },
    },
    headCells: {
      style: {
        borderBottom: '2px solid #ccc', // Garis bawah yang lebih tebal pada header
        backgroundColor: '#6f42c1', // Warna latar belakang header
        fontWeight: 'bold', // Membuat teks header lebih tegas
        textAlign: 'center', // Membuat thead ke tengah
        justifyContent: 'center', // Pusatkan konten secara horizontal
        color: '#FFFF',
      },
    },
    cells: {
      style: {
        borderRight: '1px solid #ddd', // Garis pemisah antar kolom
        padding: '10px', // Padding agar lebih rapi
      },
    },
  };

  return (
    <>
      <div style={{ overflowX: 'auto', maxWidth: '1200px' }}>
        <DataTable
          columns={columns}
          data={props?.listRiskManagement}
          customStyles={customStyles}
          pagination
          fixedHeader
          highlightOnHover
          subHeader
          subHeaderComponent={
            <input
              type="text"
              placeholder="Cari Rencana Penanganan"
              className="w-50 form-control m-3"
              values={props.searchMP}
              onChange={(e) => props.handleChangeSearchMP(e.target.value)}
            />
          }
          subHeaderAlign="center"
        />
      </div>
    </>
  );
};

export default DatatableRiskManagementPlan;
